import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Validation } from 'src/app/config/validation';
import { AuthService } from '../auth.service';
import { NotificationService } from 'src/app/config/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
  newPasswordForm!: FormGroup;
  token:any;
  user: any;
  hidePassword: boolean = true;
  hidePassword1: boolean = true;

  constructor(private activatedRoute: ActivatedRoute,private authService: AuthService,private toastr: NotificationService,private router: Router) {
    this.token = this.activatedRoute.snapshot.queryParams['token'];
   }

  ngOnInit(): void {
    this.newPasswordForm = new FormGroup(
      {
        vPassword: new FormControl('', [
          Validators.required
        ]),
        confirmPassword: new FormControl('', [
          Validators.required
        ]),
      },
      {
        validators: [Validation.match('vPassword', 'confirmPassword')],
      }
    );
  }

  newPasswordHandle(){
    this.user = {
      vPassword: this.newPasswordForm.value.vPassword
    };

    const tokenID = this.token; 
  if (!tokenID) {
    this.toastr.showWarning('Invalid or missing token', '');
    return;
  }

    this.authService.newPassword(this.user,tokenID).subscribe((result) => {
      if (result['code'] == 200) {
        this.toastr.showSuccess(result['message'], '');
        this.router.navigate(['login']);
      }
    })
  }

}
